import { computed } from "nanostores";

import { getAlertSource, listAlertSources } from "../api";
import { createPaginationStore } from "../stores/pagination.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $alertSourcesPagination = createPaginationStore();

const $paginationParamsString = computed(
  $alertSourcesPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $alertSourcesList = createApiStore(listAlertSources, {
  mapToOptions: ([paginationParamsString]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    return {
      query: {
        currentPage: paginationParams.currentPage,
        pageSize: paginationParams.pageSize,
      },
    };
  },
  params: [
    $paginationParamsString,
    computed($router, (route) => String(route?.route)),
  ],
  storeKey: "alertSourcesList",
});

export const $alertSourceContent = createApiStore(getAlertSource, {
  mapToOptions: ([alertSourceId]) => ({
    path: { id: alertSourceId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "sourceId" in router.params ? router.params.sourceId : null;
    }),
  ],
  storeKey: "alertSourceContent",
});
